import { forwardRef, type InputHTMLAttributes } from "react";
import { cn } from "@/lib/utils";

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          "flex h-11 w-full rounded-xl bg-daydra-raised px-4 text-sm text-daydra-text",
          "border border-daydra-border",
          "placeholder:text-daydra-muted",
          "transition-colors duration-200",
          "focus:outline-none focus:border-daydra-accent/50 focus:ring-1 focus:ring-daydra-accent/20",
          "disabled:cursor-not-allowed disabled:opacity-40",
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);

Input.displayName = "Input";
